import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Button from '@mui/material/Button';

import { getNotificationsSelector } from '../state-manager/selectors/notificationsSelectors';
import { removeNotification } from '../state-manager/slices/notificationsSlice';
import { colors } from '../style/colors';

let displayed: string[] = [];

export default function useNotifier() {
  const dispatch = useDispatch();
  const notifications = useSelector(getNotificationsSelector);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id: string) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id: string) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(
      ({ id, message, dismissed = false, severity, origin }) => {
        if (dismissed) {
          closeSnackbar(id);
          return;
        }

        if (displayed.includes(id)) {
          return;
        }

        enqueueSnackbar(message, {
          key: id,
          action: () => (
            <Button
              variant="outlined"
              size="small"
              // White outline and text: MUI's default primary blue was hard to read on the
              // red, green and orange banners. White reads on every severity colour.
              sx={{
                color: colors.white,
                borderColor: 'rgba(255, 255, 255, 0.8)',
                '&:hover': {
                  borderColor: colors.white,
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                },
              }}
              onClick={() => closeSnackbar(id)}
            >
              dismiss me
            </Button>
          ),
          onExited: (_, myKey) => {
            const idStr = `${myKey}`;
            dispatch(removeNotification({ id: idStr }));
            removeDisplayed(idStr);
          },
          variant: severity,
          anchorOrigin: origin,
        });
        storeDisplayed(id);
      },
    );
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);
}
